import { useQuery } from '@apollo/client';
import { GET_PORTALIO_AUTH_DETAILS } from 'src/graphql/entities/integrations/portalio/portalio.operations';
import { PortalioAuthResponse } from 'src/pages/Settings/integrations/portalio/portalio-integration-view';
import { useNotifications } from 'src/utils/hooks';

export const useGetPortalioAuthDetails = () => {
  const { showErrorAlert } = useNotifications();
  const { data, loading } = useQuery<PortalioAuthResponse>(
    GET_PORTALIO_AUTH_DETAILS,
    {
      onError: (data) => {
        showErrorAlert(data.message);
      },
    },
  );

  return {
    portalioAuthDetails: data?.getPortalioUserAuthDetails?.authDetails,
    loading,
  };
};
